import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";
import { ShieldCheck, Lock, User } from "lucide-react";

export default function AdminLoginPage() {
  const { admin, login } = useAdminAuth();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  if (admin && typeof admin === "object") {
    const from = location.state?.from || "/admin/users";
    return <Navigate to={from} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    const res = await login(username, password);
    setLoading(false);
    if (!res.ok) setErr(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-gray-900 to-red-950/30 px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-[#0b0f1a] border border-red-900/40 rounded-lg p-6 space-y-5 shadow-2xl">
        <div className="flex items-center gap-2">
          <ShieldCheck className="w-6 h-6 text-red-400" />
          <h1 className="text-xl font-bold text-white">Admin Console</h1>
        </div>
        <p className="text-xs text-gray-500">Restricted area. Admin credentials required.</p>

        <form onSubmit={submit} className="space-y-3" data-testid="admin-login-form">
          <label className="block">
            <span className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold">Username or email</span>
            <div className="relative mt-1">
              <User className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" />
              <input type="text" required autoComplete="username" data-testid="admin-username-input"
                value={username} onChange={(e) => setUsername(e.target.value)}
                className="w-full pl-8 pr-3 py-2 bg-gray-900 border border-gray-700 rounded text-white text-sm focus:outline-none focus:border-red-500"
                placeholder="admin or you@example.com" />
            </div>
          </label>
          <label className="block">
            <span className="text-[11px] uppercase tracking-wide text-gray-500 font-semibold">Password</span>
            <div className="relative mt-1">
              <Lock className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" />
              <input type="password" required autoComplete="current-password" data-testid="admin-password-input"
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-8 pr-3 py-2 bg-gray-900 border border-gray-700 rounded text-white text-sm focus:outline-none focus:border-red-500"
                placeholder="••••••••" />
            </div>
          </label>

          {err && (
            <div className="p-2 text-xs rounded border border-red-900/60 bg-red-950/30 text-red-300" data-testid="admin-login-error">{err}</div>
          )}

          <button type="submit" disabled={loading} data-testid="admin-login-submit-button"
            className="w-full py-2 rounded bg-red-600 hover:bg-red-500 text-white font-semibold text-sm disabled:opacity-50 transition-colors">
            {loading ? "Signing in…" : "Sign in to admin"}
          </button>
        </form>
      </div>
    </div>
  );
}
